module.exports = "/_next/static/images/polis-16b05f15cb840dc5d629564ea1c89be6.png";